import _ from 'lodash';
export var intlConfigByCurrency = {
  USD: {
    locale: 'en-US',
    currency: 'USD'
  }
};
export function getValidValue(value, integerLimit, decimalLimit) {
  if (_.isNil(value)) {
    return undefined;
  }

  var stringValue = String(value);
  var negative = stringValue.startsWith('-');
  var absoluteValue = negative ? stringValue.slice(1) : stringValue;
  var [integerPart = '', decimalPart = ''] = absoluteValue.split('.');
  var hasDecimal = !!decimalPart || absoluteValue.endsWith('.');
  var concatNumber = integerPart + decimalPart;
  var validIntegerPart = concatNumber.slice(0, Math.min(integerLimit, integerPart.length));
  var validDecimalPart = hasDecimal ? ".".concat(concatNumber.slice(validIntegerPart.length, validIntegerPart.length + Math.min(decimalLimit, decimalPart.length))) : '';
  return "".concat(negative ? '-' : '').concat(validIntegerPart).concat(validDecimalPart);
}
//# sourceMappingURL=currencyInputHelper.js.map